query POStatusChartData {
  kpiPoStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
